import { render, staticRenderFns } from "./AiRecommendationsRow.vue?vue&type=template&id=ec4e8d06&scoped=true&"
import script from "./AiRecommendationsRow.vue?vue&type=script&lang=js&"
export * from "./AiRecommendationsRow.vue?vue&type=script&lang=js&"
import style0 from "./AiRecommendationsRow.vue?vue&type=style&index=0&id=ec4e8d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4e8d06",
  null
  
)

export default component.exports